import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleModal } from '../Actions';
class ComponentModal extends Component {
    constructor(props) {
        super(props);
        this.content = React.createRef();
        this.onOverlayClick = this.onOverlayClick.bind(this);
    }
    componentDidUpdate() {
        const { show, onScroll } = this.props;
        if (show && onScroll) {
            // Prevent scroll on anything
            this.content.current.addEventListener('touchmove', onScroll, false);
        }
    }
    onOverlayClick(e) {
        const { displayClose, overlayClickClose, onClose } = this.props;
        // Only close if click event is directly on the overlay
        // eslint-disable-next-line react/no-string-refs
        if (displayClose && e.target === this.refs.overlay && overlayClickClose) {
            onClose();
        }
    }
    render() {
        const { show, id, classNames, title, content, children, displayClose, onClose } = this.props;
        if (!show) {
            return null;
        }
        return (_jsx("div", Object.assign({ role: "button", tabIndex: 0, id: id, 
            // eslint-disable-next-line react/no-string-refs
            ref: "overlay", className: "reveal-overlay", onClick: this.onOverlayClick, style: { display: 'block' } }, { children: _jsxs("div", Object.assign({ className: `reveal ${classNames}`, style: { display: 'block' }, ref: this.content }, { children: [displayClose && (_jsx("button", Object.assign({ onClick: onClose, className: "close-button", "aria-label": "Close modal", type: "button" }, { children: _jsx("span", Object.assign({ "aria-hidden": "true" }, { children: "\u00D7" })) }))), _jsx("div", Object.assign({ className: "reveal-box row" }, { children: _jsx("div", Object.assign({ className: "columns small-12" }, { children: _jsxs("div", Object.assign({ className: "reveal-content text-left" }, { children: [title && _jsx("h2", { children: title }), content && _jsx("p", { children: content }), children] })) })) }))] })) })));
    }
}
ComponentModal.propTypes = {
    id: PropTypes.string,
    classNames: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    show: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node.isRequired,
    displayClose: PropTypes.bool,
    onScroll: PropTypes.func,
    overlayClickClose: PropTypes.bool
};
ComponentModal.defaultProps = {
    id: '',
    classNames: '',
    displayClose: true,
    overlayClickClose: true
};
const mapStateToProps = (state, ownProps) => { var _a; return ({ show: ((_a = state === null || state === void 0 ? void 0 : state.application) === null || _a === void 0 ? void 0 : _a.modal) && state.application.modal === ownProps.modalKey }); };
const mapDispatchToProps = (dispatch, ownProps) => {
    const props = {};
    if (!ownProps.onClose) {
        props.onClose = () => {
            dispatch(toggleModal());
            if (ownProps.onClosed) {
                ownProps.onClosed();
            }
        };
    }
    return props;
};
export default connect(mapStateToProps, mapDispatchToProps)(ComponentModal);
